import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {ClientDashboardModel} from "../models/ClientDashboardModel";
import {Branding} from "../../../types/Branding";
import {IInvestClientDashboardModelProvider} from "./iinvest/IInvestClientDashboardModelProvider";
import {IVClientDashboardModelProvider} from "./iv/IVClientDashboardModelProvider";

export class ClientDashboardService {

    public static id = "clientDashboardService";

    /** @ngInject */
    public constructor(private currentUserService: CurrentUserService,
                       private iinvestClientDashboardModelProvider: IInvestClientDashboardModelProvider,
                       private ivClientDashboardModelProvider: IVClientDashboardModelProvider) {
    }

    public async model(): Promise<ClientDashboardModel> {
        if (this.currentUserService.isBranding(Branding.IV)) {
            return this.ivClientDashboardModelProvider.model();
        } else if (this.currentUserService.isBranding(Branding.IINVEST)) {
            return this.iinvestClientDashboardModelProvider.model();
        } else {
            throw Error("not implemented");
        }
    }
}
